import PropTypes from "prop-types";
import React, { Component } from "react";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import { getCities, getDepartments } from "./actions";
import SelectFieldFormat from "../SelectFieldFormat/SelectFieldFormat";

class SelectDepartments extends Component {
    state = {
        firstInto: false,
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { initialValue } = nextProps;
        if (!_.isUndefined(initialValue) && !this.state.firstInto) {
            nextProps.getDepartments(initialValue);
            this.setState({
                firstInto: true,
            });
        }
    }

    _onChange(department) {
        const { getCities, field2 } = this.props;
        getCities(department);
        field2.onChange(null);
    }

    render() {
        const { config, field, departments } = this.props;
        return (
            <SelectFieldFormat
                config={_.assign(
                    {
                        value: field.value,
                        autoWidth: true,
                        errorText: field.touched && field.error ? field.error : "",
                        onChange: (e, index, value) => {
                            field.onChange(value);
                            this._onChange(value);
                        },
                    },
                    { ...config },
                )}
            >
                {_.map(_.orderBy(departments, ["name"]), item => (
                    <MenuItem key={item._id} value={item._id} primaryText={item.name} />
                ))}
            </SelectFieldFormat>
        );
    }
}

function mapStateToProps({ master }, ownProps) {
    return {
        departments: master.departments,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getCities,
            getDepartments,
        },
        dispatch,
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectDepartments);
